const today = new Date();

const formattedDate = today.toLocaleDateString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
});  

const additionalContextText = (userInfo) => `AdditionalContext: Today's date is: ${formattedDate}. The following is some additional context about the specific user your speaking to: 
        User's Name: ${userInfo.firstName} ${userInfo.lastName}
        User's Company: ${userInfo.company}
        User's Email: ${userInfo.email}`;
        
        
export const additionalContextMessage = (userInfo)=>{ return ({ role: "user", parts: [{ text: additionalContextText(userInfo) }]})}